/**
 * Formats a number or string as a price with commas as thousand separators.
 * Includes cents only if they are not "00".
 *
 * @param {number | string} price - The number or string to be formatted.
 * @returns {string} The formatted price as a string.
 *
 * @example
 * // Returns "1,234"
 * formatPrice(1234);
 *
 * @example
 * // Returns "1,234.56"
 * formatPrice(1234.56);
 *
 * @example
 * // Returns "0"
 * formatPrice(0);
 */
export const formatPrice = (price: number | string): string => {
  if (price === null || price === undefined || Number.isNaN(Number(price))) {
    return "0";
  }

  const num = typeof price === "string" ? Number.parseFloat(price) : price;

  // Format the number to include two decimal places
  const formattedNum = num.toFixed(2);

  // Split into whole and decimal parts
  const [whole, decimal] = formattedNum.split(".");

  // Add commas as thousand separators to the whole part
  const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Include the decimal part only if it's not "00"
  return decimal === "00" ? formattedWhole : `${formattedWhole}.${decimal}`;
};
